import { TimeInput } from '@components/timeInput';
import { FormField } from '@components/ui/form';
import { DatePicker } from '@components/ui/form/date';
import { FormItemWrapper } from '@components/ui/form/itemWrapper';
import { useTranslation } from 'react-i18next';
import { getDate, getHours, getMinutes, parseISO, set } from 'date-fns';
import { ExternalScheduleDateInputsProps } from './types';
import { useFormContext } from 'react-hook-form';
import { useRescheduler } from '@contexts/rescheduler';

export const ExternalScheduleDateInputs = ({
  data,
  disabled,
  children,
}: ExternalScheduleDateInputsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms' });
  const rescheduler = useRescheduler();

  const { control, setValue, watch } = useFormContext<{
    date: Date;
    time?: Date;
    startsAt?: string;
  }>();

  const { startsAt } = watch();

  const parseValue = (value?: unknown) => {
    return (value as Date) || null;
  };

  return (
    <div className="flex gap-4">
      <FormField
        control={control}
        name="date"
        render={({ field: { value, onChange, ...field } }) => (
          <FormItemWrapper className="w-fit" label={t('date.label')} required>
            <DatePicker
              value={parseValue(value)}
              onChange={(v) => {
                if (data && rescheduler) rescheduler.removeSavedSchedule(data);
                onChange(v);
                if (!v || !startsAt) return;
                setValue('startsAt', set(parseISO(startsAt), { date: getDate(v) }).toISOString());
              }}
              mode="single"
              className="w-[180px]"
              disabled={disabled}
              placeholder={t('default.select.placeholder')}
              {...field}
            />
          </FormItemWrapper>
        )}
      />
      <FormField
        control={control}
        name="time"
        render={({ field: { value, onChange, ...field } }) => (
          <FormItemWrapper className="w-fit" label={t('time.label')} required>
            <TimeInput
              {...field}
              asInput
              id={field.name}
              value={parseValue(value)}
              disabled={disabled}
              onValueChange={(v) => {
                if (data && rescheduler) rescheduler.removeSavedSchedule(data);
                onChange(v);
                if (!v || !startsAt) return;
                setValue(
                  'startsAt',
                  set(parseISO(startsAt), {
                    hours: getHours(v),
                    minutes: getMinutes(v),
                  }).toISOString(),
                );
              }}
            />
          </FormItemWrapper>
        )}
      />
      {children}
    </div>
  );
};
